import { jsx as n, jsxs as z, Fragment as v } from "react/jsx-runtime";
import q, { useState as B, useId as F, useEffect as P, cloneElement as w } from "react";
import { c as h } from "../clsx-OuTLNxxd.js";
import { A as R, E as U } from "../index-D6IbTb4M.js";
import '../Accordion.css';const j = "320px", L = "600px", O = "1025px", D = "_header_1m2mi_33", G = "_splitHeader_1m2mi_37", J = "_iconSlot_1m2mi_43", K = "_heading_1m2mi_50", Q = "_toggle_1m2mi_57", X = "_triggerElement_1m2mi_66", Y = "_indicator_1m2mi_72", Z = "_trigger_1m2mi_66", M = "_contentElement_1m2mi_112", V = "_content_1m2mi_112", C = "_primary_1m2mi_132", N = "_secondary_1m2mi_135", ee = "_item_1m2mi_141", te = "_dense_1m2mi_141", ie = "_nav_1m2mi_234", ne = "_link_1m2mi_239", oe = "_headingText_1m2mi_271", ce = "_linkLabel_1m2mi_272", re = "_linkList_1m2mi_297", t = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: j,
  "mobile-wide": "480px",
  tablet: L,
  "tablet-wide": "800px",
  desktop: O,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  header: D,
  splitHeader: G,
  iconSlot: J,
  heading: K,
  toggle: Q,
  triggerElement: X,
  indicator: Y,
  trigger: Z,
  contentElement: M,
  content: V,
  primary: C,
  secondary: N,
  item: ee,
  dense: te,
  nav: ie,
  link: ne,
  headingText: oe,
  linkLabel: ce,
  linkList: re
}, le = (d) => {
  if (typeof requestAnimationFrame != "function")
    return d(), () => {
    };
  let x = 0;
  const c = requestAnimationFrame(() => {
    x = requestAnimationFrame(d);
  });
  return () => {
    cancelAnimationFrame(c), cancelAnimationFrame(x);
  };
}, de = ({
  animationDurationMs: d = 0,
  indicatorSize: x = "xsm",
  isOpen: c,
  isPanelLandmark: e = !0,
  onChange: a,
  stroke: W = "bold"
}) => {
  const [i, y] = B(c), s = d > 0, [f, p] = B(c), [u, m] = B(!!c), b = F(), g = F(), H = () => {
    a == null || a(!i), y(!i);
  };
  P(() => {
    c !== i && y(c);
  }, [c]), P(() => {
    if (!s) return;
    if (i)
      return p(!0), le(() => m(!0));
    m(!1);
    const r = setTimeout(() => p(!1), d);
    return () => clearTimeout(r);
  }, [i, s, d]);
  const _ = {
    "aria-controls": g,
    // The watermark travels with the hook, not just with `Accordion.Item`. A caller that drives the
    // disclosure headlessly renders cxy's behaviour on markup of its own — the footer nav does — and
    // without this it is indistinguishable in the DOM from a hand-rolled toggle, which is the one
    // question `data-cxy-name` exists to answer.
    "data-cxy-name": "accordion",
    "aria-expanded": i,
    "data-state": i ? "open" : "closed",
    id: b,
    onClick: H
  }, o = {
    "aria-labelledby": b,
    className: t.contentElement,
    hidden: s ? !f : !i,
    id: g,
    ...e ? { role: "region" } : {},
    ...s ? { "data-animated": "" } : {},
    ...s && u ? { "data-enter": "" } : {}
  };
  return {
    headingProps: _,
    sectionProps: o,
    triggerClass: t.triggerElement,
    Indicator: () => W === "bold" ? /* @__PURE__ */ n(R, { className: t.indicator, size: x }) : /* @__PURE__ */ n(U, { className: t.indicator, size: x })
  };
}, ye = 300, xe = ({
  animationDurationMs: d = 0,
  chevronStroke: x = "bold",
  children: c,
  classNames: e,
  heading: a,
  headingAs: W = "h3",
  icon: i,
  indicator: y,
  indicatorSize: s = "xsm",
  isDense: f = !1,
  isOpen: p = !1,
  isPanelLandmark: u = !0,
  links: m,
  onChange: b,
  onLinkClick: g,
  testId: H,
  toggleLabel: _,
  trackingAttribute: o,
  variant: r
}) => {
  const { Indicator: l, headingProps: E, sectionProps: A, triggerClass: I } = de({
    animationDurationMs: d,
    isOpen: p,
    isPanelLandmark: u,
    onChange: b,
    indicatorSize: s,
    stroke: x
  }), T = {
    ...E,
    ...o ? { "data-analytics": o } : {},
    ...H ? { "data-testid": H } : {},
    type: "button"
  }, { id: $, ...k } = T;
  return /* @__PURE__ */ z(
    "div",
    {
      className: h(
        t.item,
        { [t.dense]: f },
        r && r !== "bare" && t[r],
        e == null ? void 0 : e.wrapper
      ),
      "data-cxy-name": "accordion",
      children: [
        /* @__PURE__ */ n(W, { className: h(t.header, { [t.splitHeader]: _ }, e == null ? void 0 : e.header), children: _ ? /* @__PURE__ */ z(v, { children: [
          /* @__PURE__ */ z("span", { className: h(t.heading, e == null ? void 0 : e.heading), id: $, children: [
            i !== void 0 && /* @__PURE__ */ n("span", { className: t.iconSlot, children: i }),
            a
          ] }),
          /* @__PURE__ */ n(
            "button",
            {
              "aria-label": _,
              className: h(I, t.toggle, e == null ? void 0 : e.button),
              ...k,
              children: y ?? /* @__PURE__ */ n(l, {})
            }
          )
        ] }) : /* @__PURE__ */ z("button", { className: h(I, t.trigger, e == null ? void 0 : e.button), ...T, children: [
          i === void 0 ? a : /* @__PURE__ */ z(v, { children: [
            /* @__PURE__ */ n("span", { className: t.iconSlot, children: i }),
            /* @__PURE__ */ n("span", { className: h(t.headingText, e == null ? void 0 : e.heading), children: a })
          ] }),
          y ?? /* @__PURE__ */ n(l, {})
        ] }) }),
        /* @__PURE__ */ n(
          "div",
          {
            ...A,
            className: h(t.content, e == null ? void 0 : e.content),
            style: { "--cxy-accordion-duration": `${d}ms` },
            children: m ? /* @__PURE__ */ n("ul", { className: t.linkList, children: m.map((S) => /* @__PURE__ */ n("li", { children: /* @__PURE__ */ z("a", { className: t.link, href: S.href, onClick: () => g == null ? void 0 : g(S), children: [
              /* @__PURE__ */ n("span", { className: t.iconSlot, children: S.icon }),
              /* @__PURE__ */ n("span", { className: t.linkLabel, children: S.label })
            ] }) }, `${S.href}-${S.label}`)) }) : c
          }
        )
      ]
    }
  );
}, se = ({
  chevronStroke: d = "bold",
  children: x,
  defaultOpen: c,
  indicatorSize: e = "xsm",
  isDense: a = !1,
  name: W,
  onValueChange: i,
  type: y = "single",
  value: s,
  variant: f = "primary"
}) => {
  const p = y === "multiple", u = s !== void 0, m = q.Children.toArray(x), b = c ? m.map(() => !0) : m.map((o) => !!o.props.isOpen), [g, H] = B(b), _ = (o, r) => {
    let l = [];
    p ? (l = [...g], l[r] = o) : (l = m.map(() => !1), o === !0 && (l[r] = !0)), H(l);
  };
  return /* @__PURE__ */ n(
    "div",
    {
      className: h(t.accordion, f !== "bare" && t[f]),
      "data-cxy-name": "accordion",
      "data-testid": "accordion-component",
      children: x && m.map(
        (o, r) => (
          // Cloned rather than rebuilt from named props: every prop the item declares reaches it,
          // so adding one to `AccordionItemProps` does not also require adding it here.
          w(o, {
            chevronStroke: d,
            indicatorSize: e,
            isDense: a,
            variant: f,
            isOpen: u ? o.props.value === s : g[r],
            key: `${W}-item-${r}`,
            onChange: (l) => {
              var E, A;
              (A = (E = o.props).onChange) == null || A.call(E, l), u ? i == null || i(l ? o.props.value ?? null : null) : _(l, r);
            }
          })
        )
      )
    }
  );
};
se.Item = xe;
export {
  ye as ACCORDION_FADE_DURATION_MS,
  se as Accordion,
  de as useToggle
};
